<!--
  * @Editor: chenqy
  * @Description: 发送短信
  * @Date: 2021-06-09 17:05:35
  * @LastEditors: Chenqy
  * @LastEditTime: 2022-04-18 12:04:43
 -->
<template>
  <div class="sms-teas-message ds-control">
    <div class="teas-message-header">
      <div class="teas-header-title">发短信</div>
      <div class="teas-header-send">
        <!-- 发送参数1 -->
        <div class="ds-sms-header-params-setting attach-params" v-if="showheadAttachparams">
          <div class="header-params-setting" ref="headerparams" slot-name="headerparams">
            <slot name="headerparams"></slot>
          </div>
        </div>
        <!-- <div
          class="teas-header-check"
          :class="{ 'teas-header-check-true': isRightNowSend }"
          @click="handleSend(true)"
        >
          <i v-show="isRightNowSend" class="el-icon-check"></i>
        </div>
        <div class="teas-header-text" style="margin-right: 40px">立即发送</div> -->
        <div class="teas-header-btn" style="margin-left: 0" @click="handleSendMessage('send')" title="发送"><i class="el-icon-position"></i>发送</div>
        <div class="teas-header-btn" @click="handleSendMessage('draft')" title="保存至草稿箱">保存至草稿箱</div>
        <el-upload
          class="teas-header-btn"
          slot="append"
          :headers="dsf.getDefaultHttpHeader()"
          :accept="accept"
          :action="action"
          :show-file-list="false"
          :on-progress="uploadProgress"
          :on-success="uploadSuccess"
          :on-error="uploadError"
        >
          <div class="teas-header-btn-text" title="导入手机号">导入手机号</div>
        </el-upload>
        <div class="teas-header-btn" @click="downloadMode" title="模版下载">模版下载</div>
      </div>
    </div>
    <div class="teas-message-body">
      <div class="teas-body-left" :style="{ width: allNavList.length > 4 ? '535px' : '480px' }">
        <el-tabs v-model="navActive" @tab-click="handleChangeNav" class="teas-message-tabs">
          <el-tab-pane v-for="item in defaultNavList" :key="item.name" :label="item.title" :name="item.name" :lazy="true">
            <template v-if="!item.haschild || item.child.length == 0">
              <message-tree
                v-if="item.displayMode == 'tree'"
                :name="item.name"
                :ref="item.name"
                :sms-data="item"
                :defaultOpenSeries="item.defaultOpenSeries"
                :is-design="isDesign"
                @handle-add="handleAddUser"
                @call-back="childCallback"
                @handle-delete="handleDelete"
              />
              <index-bar
                v-else
                :name="item.name"
                :ref="item.name"
                :sms-data="item"
                :defaultOpenSeries="item.defaultOpenSeries"
                :is-design="isDesign"
                @handle-add="handleAddUser"
                @call-back="childCallback"
                @handle-delete="handleDelete"
                @handle-delete-tree="handleDeleteTree"
              />
            </template>
            <template v-else>
              <el-tabs :value="twoLevelActiveFind(item.name)" type="card" class="teas-card-tabs">
                <el-tab-pane
                  v-for="(tempItem, tempIndex) in item.child"
                  :key="'twoleveltree' + tempIndex"
                  :label="tempItem.title"
                  :name="tempItem.name"
                  :lazy="true"
                >
                  <message-tree
                    :name="tempItem.name"
                    :ref="tempItem.name"
                    :sms-data="tempItem"
                    :defaultOpenSeries="tempItem.defaultOpenSeries"
                    :is-design="isDesign"
                    @handle-add="handleAddUser"
                    @call-back="childCallback"
                    @handle-delete="handleDelete"
                  />
                </el-tab-pane>
              </el-tabs>

              <!-- <div class="sendmessage-twolevel-div">
                <div class="sendmessage-twoleveltab-div">
                  <div
                    class="sendmessage-twoleveltab-item"
                    v-for="(tempItem, tempIndex) in item.child"
                    :key="'twoleveltab' + tempIndex"
                    @click="clickTwoTab(index, tempItem)"
                  >
                    <div :class="tempIndex == 0 ? 'item-content-noborder' : 'item-content-normal'">
                      <div :class="tempItem.name == item.active ? 'item-content-select' : 'item-content-notselect'">
                        {{ tempItem.title || "" }}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="sendmessage-twoleveltree-div"
                  v-for="(tempItem, tempIndex) in item.child"
                  :key="'twoleveltree' + tempIndex"
                  v-show="tempItem.name == item.active"
                >
                  <div class="teas-body-tree-c">
                    <message-tree
                      class="teas-body-tree"
                      :name="tempItem.name"
                      :ref="tempItem.name"
                      :apiAddress="tempItem.url"
                      :sms-data="tempItem"
                      @handleAdd="handleAddUser"
                      @call-back="childCallback"
                    />
                  </div>
                </div>
              </div> -->
            </template>
          </el-tab-pane>
        </el-tabs>

        <!-- <div class="teas-body-nav">
          <div class="teas-body-nav-box">
            <div class="teas-body-nav-really" :style="{ transform: 'translateX(' + navMargin + 'px)' }">
              <div
                class="teas-body-nav-item"
                :class="{ 'teas-item-active': item.name === navActive }"
                v-for="(item, index) in allNavList"
                :key="index"
                @click="handleChangeNav(item.name)"
              >
                {{ item.title }}
              </div>
            </div>
          </div>
          <div class="teas-body-btn" v-if="allNavList.length > 4">
            <i class="el-icon-arrow-left" :class="{ 'arrow-disabled': navMargin === 0 }" @click="handleMoveNav(true)"></i>
            <i
              class="el-icon-arrow-right"
              :class="{
                'arrow-disabled': Math.abs(this.navMargin) >= Math.ceil(this.allNavList.length / 4 - 1) * 480,
              }"
              @click="handleMoveNav(false)"
            ></i>
          </div>
        </div> -->
        <!-- 搜索树 -->
        <!-- <div class="teas-body-tree-main" v-for="(item, index) in defaultNavList" :key="'treelist' + index" v-show="navActive === item.name">
          <template v-if="!item.haschild || item.child.length == 0">
            <div class="teas-body-tree-c">
              <message-tree
                class="teas-body-tree"
                :name="item.name"
                :ref="item.name"
                :apiAddress="item.url"
                :sms-data="item"
                @handleAdd="handleAddUser"
                @call-back="childCallback"
              />
            </div>
          </template>
          <template v-else>
            <div class="sendmessage-twolevel-div">
              <div class="sendmessage-twoleveltab-div">
                <div
                  class="sendmessage-twoleveltab-item"
                  v-for="(tempItem, tempIndex) in item.child"
                  :key="'twoleveltab' + tempIndex"
                  @click="clickTwoTab(index, tempItem)"
                >
                  <div :class="tempIndex == 0 ? 'item-content-noborder' : 'item-content-normal'">
                    <div :class="tempItem.name == item.active ? 'item-content-select' : 'item-content-notselect'">
                      {{ tempItem.title || "" }}
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="sendmessage-twoleveltree-div"
                v-for="(tempItem, tempIndex) in item.child"
                :key="'twoleveltree' + tempIndex"
                v-show="tempItem.name == item.active"
              >
                <div class="teas-body-tree-c">
                  <message-tree
                    class="teas-body-tree"
                    :name="tempItem.name"
                    :ref="tempItem.name"
                    :apiAddress="tempItem.url"
                    :sms-data="tempItem"
                    @handleAdd="handleAddUser"
                    @call-back="childCallback"
                  />
                </div>
              </div>
            </div>
          </template>
        </div> -->
        <!-- 手动添加 -->
        <!-- <div class="teas-body-sd" v-show="navActive === 'manual'">
          <el-form
            label-position="top"
            label-width="80px"
            :model="formLabelAlign"
            class="teas-body-sd-form"
            ref="form"
          >
            <el-form-item
              label="姓名"
              prop="name"
              :rules="[
                { required: true, message: '姓名不能为空', trigger: 'blur' },
              ]"
            >
              <el-input
                v-model="formLabelAlign.name"
                :validate-event="false"
                placeholder="请输入姓名"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="手机号码"
              prop="phoneNumber"
              :rules="[
                {
                  required: true,
                  message: '手机号码不能为空',
                  trigger: 'blur',
                },
                {
                  type: 'phone',
                  validator: phoneValidate,
                  trigger: ['blur', 'change'],
                },
              ]"
            >
              <el-input
                v-model="formLabelAlign.phoneNumber"
                :validate-event="false"
                placeholder="请输入手机号码"
              ></el-input>
            </el-form-item>
            <el-button
              class="teas-body-add"
              @click="handleAddPeo"
            >添加</el-button
            >
          </el-form>
        </div> -->
        <!-- 额外增加的选项 -->
        <!-- <div
          class="teas-other-content"
          v-for="(item, index) in slots"
          v-show="item.name === navActive"
          :key="index"
          :name="item.name"
        >
          <component
            :is="item.type"
            :ref="item.name"
            class="teas-body-tree"
            :name="item.name"
            :apiAddress="item.apiAddress"
            @handleAdd="handleAddUser"
          ></component>
        </div> -->
      </div>
      <div class="teas-body-right">
        <!-- 发送参数2 -->
        <div
          class="params-setting-box"
          :class="{ 'params-setting-box-more': isExpandParams }"
          :style="[{ 'max-height': settingHeight ? settingHeight : 'unset' }, { 'padding-bottom': showMoreParams ? '20px' : '' }]"
          v-if="showAttachparams"
        >
          <div class="sendparams-setting" :class="{ 'sendparams-setting-more': isExpandParams }" ref="attachparams">
            <div class="setting-wrapper" :style="{ width: showMoreParams ? '' : '' }">
              <!-- 附加参数 -->
              <div class="ds-sms-attach-params attach-params" ref="attachparams" slot-name="default">
                <slot name="default"></slot>
              </div>
            </div>
          </div>
          <div class="more-settings" v-if="showMoreParams" @click="changeExpand">
            <i v-if="isExpandParams" class="iconfont icon-shang1">收起</i>
            <i v-else class="iconfont icon-xia1">更多</i>
          </div>
        </div>
        <div :style="{ height: 'calc(50% - ' + paramsclientHeight / 2 + 'px)' }" class="teas-body-receive">
          <div class="teas-body-title">
            <div>收件人</div>
            <div class="teas-body-title-right-button-div">
              <span class="template-div el-icon-circle-close" @click="handleClearError"> 清除错误格式</span>
              <span class="template-div el-icon-delete" @click="handleClearAllPeo"> 清空</span>
              <span class="template-div el-icon-warning-outline" @click="handleTips">&nbsp;提示</span>
            </div>
          </div>
          <div class="teas-body-title-peo" @click.self="clickReceiveView">
            <!-- 系统人员 -->
            <template v-for="(item, key) in receives">
              <div v-for="(value, i) in item" :key="i + key" class="teas-body-receive-item" @dblclick="editReceives(value, i, key)">
                <!-- 编辑时显示对应的可编辑内容 -->
                <span v-show="i + key != isShowEdit">
                  {{ value.name }}（<span
                    :class="{
                      error: formatPhone(value, i, key) || value.error,
                    }"
                  >
                    {{ value.phone }}</span
                  >）<i class="el-icon-close" @click="handleDelete(key, value, true)"></i>
                </span>
                <span v-show="i + key === isShowEdit">
                  <span class="white">（{{ editValue }}）</span>
                  <el-input class="edit-receives" v-model="editValue" v-show="isEdit" @change="changeBlur(editValue, i, key)" @blur="editBlur" />
                </span>
              </div>
            </template>
            <div class="teas-body-receive-item-input">
              <el-autocomplete
                v-model="inputPeopleString"
                :fetch-suggestions="querySearchAsync"
                :trigger-on-focus="false"
                placeholder="搜索或粘贴收件人"
                ref="receiveInput"
                @select="handleSelect"
                @change="inputBlur"
                @focus="inputFocus"
              ></el-autocomplete>
            </div>
            <!-- 手动添加人员 -->
            <!-- <div
              class="teas-body-receive-item"
              v-for="(item, index) in handleList"
              :key="index"
            >
              {{ item.name }}（{{ item.phoneNumber }}）<i
                class="el-icon-close"
                @click="handleClearPeo(index, 'handle')"
              ></i>
            </div> -->
          </div>
          <div class="teas-body-title-foot">
            共<span>{{ sendUser }}</span
            >人
          </div>
        </div>
        <div :style="{ height: 'calc(50% - ' + paramsclientHeight / 2 + 'px)' }" class="teas-body-content">
          <div class="teas-body-title">
            <span>短信内容</span>
            <div class="teas-body-title-right-button-div">
              <span class="template-div" @click="handleSuffix">短信后缀</span>
              <span class="template-div" @click="handleTemplate">短信模板</span>
            </div>
          </div>
          <div class="teas-body-title-peo">
            <!-- <el-input
              class="textarea"
              type="textarea"
              :rows="8"
              :max="contentLength"
              placeholder="请输入短信内容"
              v-model="messageContent"
              resize="none"
            >
            </el-input> -->

            <div contenteditable="true" class="text-area" ref="textarea" @input="textInput" @keyup="textInput"></div>
          </div>
          <div class="teas-body-title-content-last">
            {{ messageContentLastObject.text ? "(" + messageContentLastObject.text + ")" : "" }}
          </div>
          <div class="teas-body-title-foot">
            合计字数<span>{{ currentLength }}</span> ，请控制在{{ contentLength }}字以内
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import messageTree from "./sendMessageTree.vue";
import indexBar from "./indexBar.vue";
export default dsf.component({
  name: "DsfPlatformTeasWirte",
  ctrlCaption: "短信首页",
  mixins: [$mixins.layout],
  components: { messageTree, indexBar },
  props: {
    contentLength: {
      type: Number,
      default: 300,
    },
    // 标签配置
    tabConfig: {
      type: Array,
      default: () => [
        {
          title: "校内成员",
          name: "schoolperson",
          haschild: false,
          // hide: false,
          // lazy: false,
          url: "/sms/sms-info/getUnitUserTree",
          child: [],
          configParams: "", // 配置参数 用于tree 显示
        },
      ],
    },
    activeTab: {
      type: String,
      default: "schoolperson",
    },
    slots: {
      type: Array,
      default: function () {
        return [
          {
            name: "headerparams",
            controls: [],
          },
          { name: "default", controls: [] },
        ];
      },
    },
    //是否开启短信参数
    showAttachparams: {
      type: Boolean,
      default: false,
    },
    //是否开启顶部短信参数
    showheadAttachparams: {
      type: Boolean,
      default: true,
    },
    //是否显示更多设置
    showMoreParams: {
      type: Boolean,
      default: false,
    },
    //是否默认展开短信参数
    expandAttachparams: {
      type: Boolean,
      default: false,
    },
    //查询收件人接口
    personSearchUrl: {
      type: String,
      default: "/sms/sms-info/person/search",
    },
  },
  created() {
    // 获取再次编辑数据
    // dialog && location
    let tempArray = this.tabConfig || [];
    this.defaultNavList = tempArray.map((item) => {
      let tempItem = item;
      if (tempItem.child.length > 0 && tempItem.haschild) {
        tempItem.active = tempItem.child[0].name || "";
        // this.twoLevelActive = tempItem.child[0].name;
        this.twoLevelActive.push({ tabsName: tempItem.name, activeTab: tempItem.child[0].name });
      }
      return tempItem;
    });
    this.navActive = this.activeTab || "";
    this.isExpandParams = this.expandAttachparams;
    this.changeparamsclientHeight();
  },
  data() {
    return {
      settingHeight: "60px",
      paramsclientHeight: 100,
      isExpandParams: false,
      isRepeatSend: false,
      messageId: "", // 再次编辑页面ID
      isRightNowSend: true, // 是否为立即发送
      sendDate: "", // 发送日期
      receives: {}, // 系统短信接受人
      inputPeopleString: "",
      handlerAddName: "handle-add",
      messageContentLastObject: {},
      inputIsFocus: false,
      receivesList: [], // 编辑时拿到的数据
      handleList: [], // 手动添加人员
      defaultProps: { children: "children", label: "name" },
      messageContent: "", // 短信内容
      navActive: "", // 搜索树导航激活菜单
      navMargin: 0, // 菜单移动距离
      formLabelAlign: {}, // 手动添加
      defaultNavList: [], // 导航菜单
      treeData: [], // 树数据
      accept: ".xlsx,.xls",
      action: "/sms/sms-info/preimport/excel",
      editValue: "",
      isEdit: false,
      isShowEdit: "",
      errorPhone: "",
      currentLength: 0,
      blackList: "",
      sensitiveWords: "",
      twoLevelActive: [],
      isDialogEdit: false,
      templateCode: "",
      cronExpression: "",
      attachparams: {},
      delReceivesData:[]
    };
  },
  computed: {
    allNavList() {
      return [...this.defaultNavList];
    },
    sendUser() {
      let all = 0;
      Object.keys(this.receives).map((re) => {
        all += this.receives[re].length;
      });
      all += this.handleList.length;
      return all;
    },
  },
  methods: {
    changeExpand() {
      this.isExpandParams = !this.isExpandParams;
      this.changeparamsclientHeight();
    },
    changeparamsclientHeight() {
      setTimeout(() => {
        if (this.isExpandParams) {
          this.settingHeight = "";
          this.paramsclientHeight = this.$refs.attachparams.clientHeight + 100;
        } else {
          this.paramsclientHeight = 100;
          this.settingHeight = "60px";
        }
      }, 100);
    },
    twoLevelActiveFind(tabsName) {
      var tab = this.twoLevelActive.find((item) => {
        return item.tabsName == tabsName;
      });
      return tab.activeTab;
    },
    childCallback(treeName, treeTabIndex) {
      // 这里是做 异步时 右侧删除数据 ，展开异步树 渲染数据
      if(treeTabIndex && this.delReceivesData.length) {
        let tree = treeTabIndex.tree.args
        // 设置选中  这里还有没有显示 搜索勾选的数据 没查到
        let treeList = treeName?.$refs[treeName.name].$refs
        _.forEach(tree, (item) => {
          if(_.includes(this.delReceivesData, item.globalId)) {
            if(item.type == "user") {
              this.$nextTick(() => {
                treeList.tree.setChecked(item.globalId, false);
                treeList.tree2?.setChecked(item.globalId, false)
              })
            } else {
              // console.log('delReceivesData半选')
            }
          }
        })
      }
      // this.backShowData(treeName);
      // 待发短信编辑 草稿编辑 只请求一次
      if (this.isDialogEdit) {
        this.backShowData(treeName);
      } else {
        if (this.$dialog?.dialogArgs?.messageId) {
          let { messageId, type } = this.$dialog.dialogArgs;
          this.$http.get("/sms/sms-info/message", { messageId, type }).done((re) => {
            if (re.success) {
              this.receivesList = re.data.receivers;
              this.$refs.textarea.innerHTML = re.data.content;
              this.currentLength = this.$refs?.textarea.innerText.replace(/(<[\w\W]+?>)|\s*/gi, "").length;
              this.messageContent = re.data.content;
              this.smsMessageId = re.data.smsMessageId;
              let suffixUser = re.data.suffixUser;
              let suffix = re.data.suffix;
              if (this.showheadAttachparams || this.showAttachparams) {
                this.initAttachParams(re.data);
              }
              if (suffixUser && !suffix) {
                this.messageContentLastObject = { text: "自己", value: "-2" };
              } else {
                this.messageContentLastObject = suffix;
              }
              this.backShowData(treeName);
            } else {
              dsf.layer.message(re.message, false);
            }
          });
        }
      }
    },
    backShowData(treeName) {
      if (!this.isDialogEdit) {
        // Dialog编辑模式
        this.isDialogEdit = true;
        // 右侧数据
        this.$set(this.receives, "default", this.receivesList);
      } else {
        // 回显左侧树
        this.$nextTick(() => {
          let beforeSelect =
            this.receives[treeName.name] && this.receives[treeName.name].length
              ? _.concat(this.receives[treeName.name], this.receives["default"])
              : this.receives["default"];
          // tree 数据
          if (treeName.$refs?.[treeName.name]?.$refs.tree) {
            // 回显默认数据  下拉加载子级还没 选中的
            var ids = beforeSelect.map((item) => {
              return item.globalId;
            });
            //  设置 tree 选择数据 处理 半勾选
            let indeterminate = [];
            _.forEach(beforeSelect, (item) => {
              if (item.globalId) {
                let arr = _.split(item.globalId, ".");
                arr.forEach((item, index) => {
                  if (index < arr.length - 1) {
                    indeterminate.push(_.slice(arr, 0, index + 1).join("."));
                  }
                });
              }
            });
            // 设置选中  这里还有没有显示 搜索勾选的数据 没查到
            let treeList = treeName.$refs[treeName.name].$refs.tree;
            treeList.setCheckedKeys(ids);
            // 设置 this.receives  数据
            setTimeout(() => {
              // 获取选中
              let treeChecked = treeList.getCheckedNodes();
              // console.log('勾选数据', treeChecked)
              // 筛选选中的用户
              let filterType = _.filter(treeChecked, (item) => item.type == "user");
              if (treeChecked.length) {
                let treeCheckedKeys = _.map(filterType, "globalId");
                let ov = _.filter(this.receives.default, (o) => _.indexOf(treeCheckedKeys, o.globalId) == -1);
                this.$set(this.receives, "default", ov);
              }

              // 设置 tree 选择数据 合并没有加载出来 且 搜索勾选过的数据
              let treeData = _.uniq(_.concat(_.xor(this.receives[treeName.name], filterType), filterType));
              this.$set(this.receives, treeName.name, treeData);
              // 半勾选 ->  异步没加载的数据 显示出来
              _.forEach(_.uniq(_.flattenDeep(indeterminate)), (item) => {
                if (treeList.getNode(item)) {
                  treeList.getNode(item).indeterminate = true;
                }
              });
              // console.log('默认数据', this.receives)
            }, 500);
          } else {
            // bar 数据 直接设置选中值 个人通讯录没有挂 pid
            treeName.checkedItem = _.filter(this.receives.default, (item) => !item.pid);
            treeName.checkedLists = _.map(treeName.checkedItem, (item) => item.globalId);
            //  设置 bar 选择数据
            this.$set(this.receives, treeName.name, treeName.checkedItem);
            // 从默认数据中 筛选出剩余人员 -> default
            let dftData = _.filter(this.receives.default, (o) => _.indexOf(treeName.checkedLists, o.globalId) == -1);
            // 并级删除  真删除 做处理 。。。。。。。。。。。。
            this.$set(this.receives, "default", dftData);
          }
        });
      }
    },
    phoneValidate(rule, value, callback) {
      if (value && !/^1[0-9]{10}$/.test(value)) {
        callback(new Error("手机号码格式错误"));
      } else {
        callback();
      }
    },
    queryBlackList() {
      let bl = this.blackList;
      let node = {};
      _.forEach(this.receives, (item, key) => {
        node[key] = [];
        _.forEach(item, (val) => {
          node[key].push({
            ...val,
            error: _.includes(bl, val.phone),
          });
        });
        this.$set(this.receives, key, node[key]);
      });
    },
    querySensitiveWords() {
      let data = this.sensitiveWords;
      let text = this.messageContent;
      if (this.sensitiveWords.length > 1) {
        _.forEach(data, (item) => {
          text = text.replace(new RegExp(item, "g"), `&nbsp<b style="color:red">${item}</b>&nbsp`);
        });
      } else {
        text = text.replace(new RegExp(data[0], "g"), `&nbsp<b style="color:red">${data[0]}</b>&nbsp`);
      }
      this.$refs.textarea.innerHTML = text;
    },
    textInput(event) {
      let innerText = event?.target?.innerText.replace(/(<[\w\W]+?>)|\s*/gi, "");

      if (innerText == "") {
        this.currentLength = 0;
        this.$refs.textarea.innerHTML = "";
        this.messageContent = "";
      } else {
        this.currentLength = innerText.length;
        this.messageContent = innerText;
        // if (this.sensitiveWords) {
        //   this.querysensitiveWords();
        // }
      }
    },
    getContent() {
      let text = this.$refs.textarea.innerText;
      text = text.replace(/(<[\w\W]+?>)|\s*/gi, "");
      return text;
    },
    /**
     * type (string) 事件类型
     */
    sendMessage(type) {
      var attachparams = {};
      if (this.showheadAttachparams || this.showAttachparams) {
        [...$(".attach-params .ds-form-item")].forEach((item) => {
          if (item.__vue__.isFormControl) {
            this.$set(attachparams, item.__vue__.caption, item.__vue__.value);
          }
        });
        //定时参数
        var $setting = $(".sms-base-setting-box");
        if ($setting && $setting[0] && $setting[0].__vue__) {
          var setting = $setting[0].__vue__;
          this.sendDate = setting.sendDate;
          this.cronExpression = setting.cronExpression;
          this.isRepeatSend = setting.isRepeatSend;
          this.isRightNowSend = setting.isRightNowSend;
        }
      }
      let receives = [];
      let validatePhone = false;
      let { contentLength } = this.props;
      Object.keys(this.receives).map((re) => {
        receives.push(...this.receives[re]);
        // 过滤格式错误的手机号
        _.forEach(this.receives[re], (val) => {
          if (val.error) {
            validatePhone = true;
          }
        });
      });
      if (validatePhone) {
        //滚动到手机号错误的人员
        setTimeout(() => {
          const top = document.querySelector(".teas-body-receive-item .error");
          $(".teas-body-receive .teas-body-title-peo").scrollTop(((top && top.offsetParent && top.offsetParent.offsetTop) || 0) - 100);
          // document.querySelector(".teas-body-receive .teas-body-title-peo").scrollTo({
          //   top: ((top && top.offsetParent && top.offsetParent.offsetTop) || 0) - 100,
          //   behavior: "smooth",
          // });
        }, 500);
        dsf.layer.message("请修改收件人手机号黑名单或格式问题", false);
        return;
      }
      // validate3
      if (this.currentLength > contentLength) {
        dsf.layer.message(`短信内容不能超过${contentLength}字`, false);
        return;
      }
      // let messageStringLength = this.messageContentLastObject.text
      //   ? this.messageContent.length + this.messageContentLastObject.text.length
      //   : this.messageContent.length;
      // if (messageStringLength > contentLength) {
      //   dsf.layer.message(`短信内容不能超过${contentLength}字`, false);
      //   return;
      // }
      if (!this.isRightNowSend && !this.isRepeatSend && !this.sendDate) {
        dsf.layer.message("请选择短信发送时间", false);
        return;
      }
      if (!this.isRightNowSend && this.isRepeatSend && !this.cronExpression) {
        dsf.layer.message("请设置重复发送时间", false);
        return;
      }
      if (this.sendUser === 0) {
        dsf.layer.message("请填写短信收件人", false);
        return;
      }
      if (!this.messageContent) {
        dsf.layer.message("请输入短信内容", false);
        return;
      }
      let formatter = {
        templateCode: this.templateCode,
        content: this.messageContent,
        sendNow: this.isRightNowSend,
        sendTime: dsf.date.format(this.sendDate, "yyyy-mm-dd hh:ii:ss"),
        receivers: [...receives],
        isRepeatSend: this.isRepeatSend,
        cornValue: this.cronExpression,
        type,
      };
      if (this.messageContentLastObject.value) {
        if (this.messageContentLastObject.value.length > 0) {
          if (this.messageContentLastObject.value == "-2") {
            formatter.suffixUser = dsf.getCookie("userId") || "";
          } else if (this.messageContentLastObject.value == "-1") {
            // console.log(11);
          } else {
            formatter.suffix = this.messageContentLastObject;
          }
        }
      }
      if (this.smsMessageId) {
        formatter["smsMessageId"] = this.smsMessageId;
      }
      if (this.showheadAttachparams || this.showAttachparams) {
        formatter.parameterMap = attachparams;
      }
      let loading = dsf.layer.loading();
      this.$http
        .post(`/sms/sms-info/save`, JSON.stringify(formatter), {
          headers: { "Content-Type": "application/json;charset=UTF-8" },
        })
        .done((res) => {
          if (res.success) {
            // 清空之前的信息
            this.sendDate = "";
            this.handleList = [];
            this.messageContent = "";
            // 清空数据
            this.currentLength = 0;
            this.$refs.textarea.innerHTML = "";
            this.messageContentLastObject = {};
            this.formLabelAlign = {};
            this.clearAllPeo();
            this.clearAttachParams();
            // 待发短信编辑 草稿编辑
            if (this.$dialog && this.$dialog.dialogArgs?.messageId) {
              this.$dialog.close();
            }
            dsf.layer.message(res.message);
          } else {
            // 发送短信部分失败情况
            if (type === "send" && res.data.type === "confirm") {
              dsf.layer
                .confirm(`${res.message}`)
                .then((re) => {
                  let path = "#/pc/sms/sent/senddetails?smsMessageId=" + res.data.id;
                  dsf.layer.openDialog({
                    title: "发送详情",
                    width: "80vw",
                    height: "70vh",
                    showClose: true,
                    params: {
                      path: path,
                    },
                    btns: [
                      {
                        text: "关闭",
                      },
                    ],
                  });
                })
                .catch((e) => e);
            } else {
              // mgc/hmd
              if (res.state == 20032) {
                //  黑名单
                this.blackList = res.data;
                this.queryBlackList();
              } else if (res.state == 20033) {
                // "敏感词"
                this.sensitiveWords = res.data;
                this.querySensitiveWords();
              }
              dsf.layer.message(res.message, false);
            }
          }
        })
        .error((err) => {
          dsf.layer.message((err && err.message) || "请求异常", false);
        })
        .always(() => {
          dsf.layer.closeLoading(loading);
        });
    },
    // 清空错误格式
    handleClearError() {
      let node = {};
      _.forEach(this.receives, (item, key) => {
        node[key] = [];
        _.forEach(item, (val) => {
          if (!val.error) {
            node[key].push(val);
          } else {
            //删除左侧树相关数据
            // console.log(key, val);
            this.handleDelete(key, val, true);
          }
        });
        this.$set(this.receives, key, node[key]);
      });
      setTimeout(() => {
        dsf.layer.message("已清除错误格式手机号。");
      }, 0);
    },
    // 发送短信
    handleSendMessage(type) {
      this.sendMessage(type);
    },
    // 切换发送方式
    handleSend() {
      this.isRightNowSend = !this.isRightNowSend;
    },
    // 选择导航树
    handleChangeNav(tab, event) {
      this.navActive = tab.name;
      // console.log(tab, event);
    },
    // 左、右移动导航栏
    handleMoveNav(isLeft) {
      if (isLeft) {
        if (this.navMargin < 0) {
          this.navMargin += 480;
        }
      } else {
        if (Math.abs(this.navMargin) < Math.ceil(this.allNavList.length / 4 - 1) * 480) {
          this.navMargin -= 480;
        }
      }
    },
    handleDelete(name, delData, checked) {
      let data = this.receives[name];
      // 从右侧数据中删除
      let dft = _.filter(data, (item) => {
        if (delData.globalId) {
          return !_.includes(item.globalId, delData.globalId);
        } else if (delData.id) {
          return !_.includes(item.id, delData.id);
        } else if (delData.phone) {
          return !_.includes(item.phone, delData.phone);
        } else {
          return item;
        }
      });
      // 从左侧树 取消勾选
      let parentVm = this.$refs[name]?.[0];
      let ids = _.map(dft, 'globalId');
      // tree数据  +  右侧删除按钮点击
      if (parentVm?.$refs[name] && checked ) {
        // 当前左侧节点已找到
        let checkNode =  parentVm.$refs[name].$refs.tree.getNode(delData.globalId)
        if(checkNode) {
          // 找到tree  右侧删除数据处理数据有问题
          parentVm.$refs[name].$refs.tree.setChecked(delData.globalId, false);
          parentVm.$refs[name].$refs.tree2?.setChecked(delData.globalId, false)
        } else {
          // 放入待删除字段内 
          this.delReceivesData.push(delData.globalId)
        }
      } else {
        if (name != "default") {
          // indexbar
          if (parentVm) {
            parentVm.checkedItem = dft;
            parentVm.checkedLists = _.map(dft, (item) => item.globalId);
          }
        }
      }
      this.$set(this.receives, name, dft);
    },
    //通过左侧树名称删除对应右侧数据
    handleDeleteTree(name) {
      this.$set(this.receives, name, []);
    },
    // 从树/列表 组件添加选中用户信息
    handleAddUser(treeName, data, checked) {
      let name = treeName.name;
      // console.log('handleAddUser',treeName, this.receives, checked)
      // 弹窗编辑
      if (this.isDialogEdit && this.receives?.default) {
        // 添加
        if (!checked) {
          // console.log('?', )
        } else {
          let selData = _.map(data, (item) => item.globalId);
          // 默认数据
          let dft = _.filter(this.receives?.default, (item) => {
            return _.indexOf(selData, item.globalId) == -1;
          });
          this.$set(this.receives, "default", dft);
        }
      }
      if (name) {
        // 当前tree数据
        let nowData = this.receives[name];
        // 默认可能 没有数据  就不合并
        let resData = nowData ? _.uniqBy(_.concat(nowData, data), "globalId") : data;
        let peos = [];
        resData.forEach((item) => {
          if (item.type == "user") {
            peos.push(item);
          }
        });
        // 搜索时 勾选
        if (treeName.searchName) {
          // 勾选
          var ids = peos.map((item) => {
            return item.globalId;
          });
          // let treeList  = treeName.$refs[name].$refs.tree2
          // treeList.setCheckedKeys(ids)
        }
        // let treeData = _.uniq(_.concat(_.xor(nowData, peos), peos))

        // console.log('peos',nowData,  peos, this.receives )
        this.$set(this.receives, name, peos);
      }
    },
    editBlur() {
      this.isShowEdit = "";
    },
    changeBlur(res, i, name) {
      let tempArray = this.receives[name] || [];
      let tempObject = {
        ...tempArray[i],
        name: res.slice(0, -11),
        phone: res.slice(-11),
        error: false,
      };
      tempArray.splice(i, 1, tempObject);
      this.isShowEdit = "";
    },
    // 编辑当前人
    editReceives(res, i, name) {
      this.isEdit = true;
      this.isShowEdit = i + name;
      this.editValue = res.name + res.phone;
    },
    formatPhone(str, index, type) {
      // let regx = /(^1(3|4|5|7|8|9|6)\d{9}$|^0[\d]{2,3}-[\d]{7,8}$|^400[-]?[\d]{3}[-]?[\d]{4}$)/g;
      let regx = /^1(3|4|5|7|8|9|6)\d{9}$/g;
      let phoneNums = regx.test(str.phone);
      if (!phoneNums) {
        str.error = true;
        // console.log("记录错误的", index, type);
      }
      return !phoneNums;
    },

    // 删除选中的人
    handleClearPeo(index, type, key) {
      if (type === "handle") {
        this.handleList.splice(index, 1);
      } else {
        // 弹窗数据删除
        if (this.isDialogEdit) {
          // 删除数据的id 无id直接删除
          let delId = this.receives[type][index]?.globalId;
          let parentVm = this.$refs[this.navActive]; // 当前激活tab
          if (delId) {
            if (parentVm[0].$refs?.tree) {
              let treeData = _.filter(parentVm[0].$refs.tree.getCheckedNodes(), (key) => key.globalId != delId);
              parentVm[0].$refs.tree.setCheckedNodes(treeData);
              // console.log("手动tree数据", treeData);
            } else {
              // console.log("手动子级 bar");
              parentVm[0].checkedItem = _.filter(parentVm[0].checkedItem, (key) => key.globalId != delId);
              parentVm[0].checkedLists = _.filter(parentVm[0].checkedLists, (key) => key != delId);
            }
          }
          // 删除当前数据
          this.receives[type].splice(index, 1);
        } else {
          // console.log("删除", index, type, key)
          let data = this.receives[type];
          let removeData = data.splice(index, 1);
          let parentVm = this.$refs[type];
          if (Object.prototype.toString.call(parentVm) === "[object Object]") {
            parentVm.$refs.tree.setCheckedNodes(data);
          } else if (Object.prototype.toString.call(parentVm) === "[object Array]") {
            // tree 数据
            if (parentVm[0].$refs?.tree) {
              parentVm[0].$refs.tree.setCheckedNodes(data);
              fixTreeChecked(
                {
                  [removeData[0].globalId]: false,
                },
                parentVm[0].$refs.tree
              );
              // var ids = data.map((item) => {
              //   return item.id;
              // });
              // parentVm[0].$refs.tree.setCheckedKeys(ids);
              // console.log(parentVm[0].$refs.tree.getCheckedKeys());
            } else {
              // bar 数据 直接设置选中值
              parentVm[0].checkedItem = data;
              parentVm[0].checkedLists = _.map(data, (item) => item.globalId);
            }
          } else {
            return;
          }
          this.$set(this.receives, type, data);
        }
      }
    },
    // 清空所有人
    handleClearAllPeo() {
      if (this.sendUser === 0) {
        dsf.layer.message("当前短信暂无收件人，请添加后再试", false);
      } else {
        dsf.layer
          .confirm("是否清空所有人？")
          .then(() => {
            this.clearAllPeo();
          })
          .catch(() => {});
      }
    },
    clearAllPeo() {
      _.map(this.defaultNavList, (item) => {
        if (item.haschild) {
          _.forEach(item.child, (childItem) => {
            this.clearTreeChecked(childItem.name);
          });
        } else {
          this.clearTreeChecked(item.name);
        }
      });
      //删除手动添加的联系人
      this.clearTreeChecked("handle-add");
    },
    // 循环处理 清空tree 数据
    clearTreeChecked(teeeName) {
      let parentVm = this.$refs[teeeName]?.[0];
      if (parentVm) {
        // tree数据
        if (parentVm?.$refs[teeeName]) {
          // 删除数据
          parentVm.$refs[teeeName].$refs.tree.setCheckedNodes([]);
        } else {
          // console.log('通讯录1')
          // bar 数据 直接设置选中值
          parentVm.checkedItem = [];
          parentVm.checkedLists = [];
        }
      }
      // 清空收件人数据
      this.$set(this.receives, teeeName, []);
      // 弹窗数据删除
      if (this.isDialogEdit) {
        this.$set(this.receives, "default", []);
      }
      this.receivesList = [];
    },
    // 手动添加联系人
    handleAddPeo() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.handleList.push(Object.assign({}, this.formLabelAlign));
          this.formLabelAlign = {};
        } else {
          return false;
        }
      });
    },
    // 短信模板
    handleTemplate() {
      let _this = this;
      this.$openDialog({
        title: "短信模版",
        width: "1000px",
        height: "66vh",
        params: {
          path: "#/pc/sms/module/template/sendModuleList?isView=1",
        },
        btns: [
          {
            text: "确定",
            handler(res) {
              let tempDic = res.$refs.view.$refs.datagrid1.multipleSelection || {};
              if (!tempDic["_id"]) {
                dsf.layer.message("请选择短信模版", false);
                return;
              } else {
                _this.templateCode = tempDic["sms_module_template.code"];
                _this.messageContent = _this.messageContent + tempDic["sms_module_template.content"];
                _this.$refs.textarea.innerHTML = _this.messageContent;
                _this.currentLength = _this.$refs.textarea.innerText.replace(/(<[\w\W]+?>)|\s*/gi, "").length;
              }
            },
          },
          {
            text: "取消",
          },
        ],
      });
    },
    handleSuffix() {
      let _this = this;
      this.$openDialog({
        title: "短信后缀",
        width: "800px",
        height: "200px",
        params: {
          path: "#/pc/sms/suffix/suffixSelect",
        },
        dialogArgs: { messageSuffix: this.messageContentLastObject },
        btns: [
          {
            text: "确定",
            handler(res) {
              _this.messageContentLastObject = res.$refs.view.chooseGroup || {};
            },
          },
          {
            text: "取消",
          },
        ],
      });
    },
    clickTwoTab(index, tempItem) {
      // let tempOneItem = this.defaultNavList[index];
      // if (tempOneItem.active == tempItem.name) {
      //   return;
      // }
      // tempOneItem.active = tempItem.name || "";
      // this.$set(this.defaultNavList, index, tempOneItem);
    },
    //输入框检索
    querySearchAsync(serchString, callback) {
      this.$http
        .get(this.personSearchUrl, {
          searchValue: serchString || "",
          pageNum: 1,
          pageSize: 100,
        })
        .done((re) => {
          if (re.success) {
            let tempData = re.data || [];
            tempData.map((item) => {
              let tempItem = item;
              tempItem.value = item.name + "（" + item.phone + "）";
              return tempItem;
            });
            callback(tempData);
          } else {
            callback([]);
            // dsf.layer.message(re.message);
          }
        })
        .error((re) => {
          callback([]);
        });
    },
    //输入框选择
    handleSelect(res) {
      let tempArray = this.receives[this.handlerAddName] || [];
      let tempObject = {
        id: res.id,
        name: res.name,
        phone: res.phone,
        pid: res.pid,
        pname: res.pname,
      };
      tempArray.push(tempObject);
      this.$set(this.receives, this.handlerAddName, tempArray);
      this.inputPeopleString = "";
    },
    inputBlur(res) {
      setTimeout(() => {
        this.inputIsFocus = false;
        if (this.inputPeopleString.length == 0) {
          return;
        }
        // 有数据 并且没手动选择
        let data = res.replace(/,|，|;|；/g, "&").split("&");
        let tempPeopleArray = this.receives[this.handlerAddName] || [];
        if (data.length > 1) {
          _.forEach(data, (list) => {
            var gid = "sms" + dsf.uuid();
            tempPeopleArray.push({
              id: "",
              globalId: gid,
              name: list.slice(0, -11),
              phone: list.slice(-11),
            });
          });
        } else {
          var gid = "sms" + dsf.uuid();
          tempPeopleArray.push({
            id: "",
            globalId: gid,
            name: data[0].slice(0, -11),
            phone: data[0].slice(-11),
          });
        }
        this.$set(this.receives, this.handlerAddName, tempPeopleArray);
        this.inputPeopleString = "";
      }, 200);
    },
    inputFocus() {
      this.isShowEdit = "";
      this.inputIsFocus = true;
    },
    selectPhoneNumber(str) {
      var regx = /(^1(3|4|5|7|8|9|6)\d{9}|0[\d]{2,3}-[\d]{7,8}|400[-]?[\d]{3}[-]?[\d]{4})/g;
      var phoneNums = str.match(regx);
      if (phoneNums) {
        if (phoneNums.length > 0) {
          return phoneNums[0];
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    clickReceiveView() {
      // 编辑时也退出
      this.isShowEdit = "";
      if (!this.inputIsFocus) {
        this.$refs.receiveInput.focus();
      }
    },
    handleImportPhone(idString) {
      //导入手机号
      let _this = this;
      this.$openDialog({
        title: "预导入文件编辑",
        width: "80%",
        height: "500px",
        center: true,
        params: {
          path: "#/pc/sms/send/import/edit?id=" + idString,
        },
        btns: [
          {
            text: "确定",
            async handler(res) {
              if (res && res.yes && !(await res.yes())) return false;
              _this.$http
                .get("/sms/sms-info/preimport/clean", {
                  id: idString,
                })
                .done((re) => {})
                .error((re) => {});
              let uploadData = res.$refs.view.$viewData["sms_send_import_user"] || [];
              let tempPeopleArray = _this.receives[_this.handlerAddName] || [];
              uploadData.forEach((item) => {
                var gid = "sms" + dsf.uuid();
                let tempItem = {
                  id: "",
                  globalId: gid,
                  name: item["sms_send_import_user.name"] || "",
                  phone: item["sms_send_import_user.phone"] || "",
                };
                tempPeopleArray.push(tempItem);
              });
              _this.$set(_this.receives, _this.handlerAddName, tempPeopleArray);
            },
          },
          {
            text: "关闭",
          },
        ],
      });
    },
    downloadMode() {
      //下载模版
      let tempButtons = _.keyBy(dsf.buttons.getPcButtons(), "actionName");
      let tempButton = tempButtons["system_template_download"];
      if (tempButton) {
        tempButton.handler.call(this, {
          owner: this,
          params: ["e52ee56f7f1b4d85a74832bccd0f45d9", "短信手机号导入模板.xlsx"],
        });
      }
    },
    uploadProgress() {
      this.loading = dsf.layer.loading();
    },
    uploadSuccess(args) {
      dsf.layer.closeLoading(this.loading);
      this.loading = undefined;
      let idString = args.data || "";
      this.handleImportPhone(idString);
    },
    uploadError() {
      dsf.layer.closeLoading(this.loading);
      this.loading = undefined;
      dsf.layer.message("上传失败", false);
    },
    handleTips() {
      dsf.layer.alert({
        title: "提示信息",
        message: "收件人可复制粘贴，多个号码请用英文的逗号/分号来区分，例如：张三13310100000；李四15110101525,张强16111110000",
        showConfirmButton: false,
      });
    },
    initAttachParams(params) {
      if (this.showheadAttachparams || this.showAttachparams) {
        var $setting = $(".sms-base-setting-box");
        if ($setting && $setting[0] && $setting[0].__vue__) {
          var setting = $setting[0].__vue__;
          this.sendDate = params.sendTime;
          this.cronExpression = params.cornValue;
          this.isRepeatSend = params.isRepeatSend;
          this.isRightNowSend = params.sendNow;
          setting.isRightNowSend = params.sendNow;
          setting.sendDate = params.sendTime;
          setting.isRepeatSend = params.isRepeatSend;
          setting.cronExpression = params.cornValue;
        }
        if (!params.parameterMap) return;
        [...$(".attach-params .ds-form-item")].forEach((item) => {
          if (item?.__vue__?.isFormControl) {
            // console.log(item.__vue__);
            if (params.parameterMap[item.__vue__.caption]) {
              this.$set(item.__vue__, "value", params.parameterMap[item.__vue__.caption]);
            }
          }
        });
      }
    },
    clearAttachParams() {
      if (this.showheadAttachparams || this.showAttachparams) {
        var $setting = $(".sms-base-setting-box");
        if ($setting && $setting[0] && $setting[0].__vue__) {
          var setting = $setting[0].__vue__;
          this.isRightNowSend = false;
          this.isRepeatSend = false;
          this.sendDate = "";
          this.cronExpression = "";
          // this.$set(setting, "isRightNowSend", true);
          // this.$set(setting, "isRepeatSend", false);
          setting.isRightNowSend = false;
          setting.isRepeatSend = false;
          setting.sendDate = "";
          setting.cronExpression = "";
        }
        [...$(".attach-params .ds-form-item")].forEach((item) => {
          if (item?.__vue__?.isFormControl) {
            this.$set(item.__vue__, "value", null);
          }
        });
      }
    },
  },
});

function fixTreeChecked(nodeKeyMap, treeVm) {
  const root = treeVm.root;
  fixTreeCheckedDeep(root, nodeKeyMap);
}
function fixTreeCheckedDeep(node, keyMap, check) {
  if (dsf.type(keyMap[node.data.globalId]) == "boolean") {
    node.checked = keyMap[node.data.globalId];
  }
  // else if (dsf.type(check) == "boolean") {
  //   node.checked = check;
  // }
  if (node.childNodes.length) {
    for (let i = 0; i < node.childNodes.length; i++) {
      fixTreeCheckedDeep(node.childNodes[i], keyMap, node.checked);
    }
  }
}
</script>
